function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * handleFetchErrors
 * @param {Object} response
 * @param {boolean} response.ok
 * @returns {Object}
 * @throws Throws if response.ok is false
 */
export var handleFetchErrors = function handleFetchErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }

  return response;
};
/**
 * toJSON
 * @param {Object} response
 * @param {Function} response.json
 * @returns {Object}
 */

export var toJSON = function toJSON(response) {
  return response.json();
};
/**
 * createHeader
 * @param {Object} options
 * @param {string} options.key
 * @param {string} [options.type]
 * @returns {Function}
 */

export var createHeader = function createHeader(_ref) {
  var key = _ref.key,
      type = _ref.type;
  return function (value) {
    var _ref2;

    return value ? (_ref2 = {}, _ref2[key] = [type, value].filter(Boolean).join(' '), _ref2) : {};
  };
};
/**
 * createAuthorizationHeader
 * @param {string} value
 * @returns {Object}
 */

export var createAuthorizationHeader = createHeader({
  key: 'Authorization',
  type: 'Bearer'
});
/**
 * createMailHashHeader
 * @param {string} value
 * @returns {Object}
 */

export var createMailHashHeader = createHeader({
  key: 'mailhash'
});
/**
 * createEmailHeader
 * @param {string} value
 * @returns {Object}
 */

export var createEmailHeader = createHeader({
  key: 'email'
});
/**
 * get
 * @param {Object} [options]
 * @param {string} [authToken]
 * @param {string} url
 * @param {string} apiVersion
 */

export var get = function get(_ref3) {
  var _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? {} : _ref3$options,
      authToken = _ref3.authToken,
      url = _ref3.url,
      apiVersion = _ref3.apiVersion;
  return fetch(url, _extends({}, options, {
    headers: _extends({}, createAuthorizationHeader(authToken), {
      'content-type': 'application/json',
      'x-api-version': apiVersion
    })
  }));
};
/**
 * post
 * @param {Object} data
 * @param {Object} [options]
 * @param {string} [authHash]
 * @param {string} [authMail]
 * @param {string} [authToken]
 * @param {string} url
 * @param {string} apiVersion
 */

export var post = function post(_ref4) {
  var data = _ref4.data,
      _ref4$options = _ref4.options,
      options = _ref4$options === void 0 ? {} : _ref4$options,
      authHash = _ref4.authHash,
      authMail = _ref4.authMail,
      authToken = _ref4.authToken,
      url = _ref4.url,
      apiVersion = _ref4.apiVersion;
  return fetch(url, _extends({}, options, {
    body: JSON.stringify(data),
    headers: _extends({}, createAuthorizationHeader(authToken), createEmailHeader(authMail), createMailHashHeader(authHash), {
      'content-type': 'application/json',
      'x-api-version': apiVersion
    }),
    method: 'POST'
  }));
};